import React from "react";

/**
 * Tiny green dot for "online". Optionally shows "Online now" as label.
 */
export const OnlineDot = ({ showLabel = false }) => (
  <div className="flex items-center gap-1">
    <span className="inline-flex h-2.5 w-2.5 rounded-full bg-emerald-400 shadow-[0_0_8px_rgba(16,185,129,0.9)]" />
    {showLabel && (
      <span className="text-[11px] font-medium uppercase tracking-wide text-emerald-300">
        Online now
      </span>
    )}
  </div>
);
